export const sinusViewOptions = [
    "Right and left maxillary sinus is clear and shows no pathology.",
    "Right and left maxillary sinus shows mild /thickening of mucosal lining.",
    "Other"
];
